import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var OptionsColor = /*#__PURE__*/function () {
  function OptionsColor() {
    _classCallCheck(this, OptionsColor);
    this.value = "#fff";
  }
  _createClass(OptionsColor, [{
    key: "load",
    value: function load(data) {
      if ((data === null || data === void 0 ? void 0 : data.value) === undefined) {
        return;
      }
      this.value = data.value;
    }
  }], [{
    key: "create",
    value: function create(source, data) {
      var color = new OptionsColor();
      color.load(source);
      if (data !== undefined) {
        if (typeof data === "string" || data instanceof Array) {
          color.load({
            value: data
          });
        } else {
          color.load(data);
        }
      }
      return color;
    }
  }]);
  return OptionsColor;
}();